<template>
  <div>
    <h1 class="text-center mt-4 fw-normal">Comandas</h1>
    <div class="form-switch form-check-reverse d-flex justify-content-center">
      <div class="btn">
        <span>COCINA ABIERTA</span>
        <input class="form-check-input" @change="open_kitchen=!open_kitchen;popup_open_kitchen=true" v-model="open_kitchen" type="checkbox" role="switch" id="switchCheckDefault">
      </div>
    </div>
    <div class="mt-4 ms-4 pb-2" id="categories-nav">
      <span class="btn rounded-5 px-3 me-3 shadow-sm" :class="{ 'active': JSON.stringify(category.id) == JSON.stringify(activeCategoryId)}" 
        v-for="(category, index) in categories" :key="index" @click="ChangeCategory(category)">
        {{category.name}}
      </span>
    </div>
    <div class="pb-1 mt-3 " id="orders-list">
      <div class="row m-0 justify-content-center" style="width: 95vw !important;" v-if="this.FilterOrders().length == 0">
        <div class="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-11 mx-auto" v-html="not_plates_founds"></div>
        <h5 class="text-center mt-1">No hay comandas en este estado</h5>
      </div>
      <div id="order-card" v-for="order in this.FilterOrders()" :key="order.id" @click="selectOrder(order)">
          <div class="d-flex justify-content-between align-items-center">
              <span>{{ formatTime(order.date) }}</span>
              <span>{{ order.table_number }}</span>
              <span></span>
          </div>
          <hr/>
          <div class="row mt-3" style="height: 80px;">
            <div class="col-8 ml-5" id="plates-list">
              <div v-for="item in order.plates" :key="item.id">
                  <span>{{ item.amount }}x</span> {{ item.name }}
              </div>
            </div>
          </div>
          <div class="row pt-2">
            <div class="col-6 d-flex justify-content-start align-items-end py-2 ps-4">
              <div v-if="order.is_delivery" class="bg-primary rounded-5 px-2 ">
                delivery
              </div>
              <div v-if="order.is_take_away" class="bg-warning rounded-5 px-2 ">
                take away
              </div>
            </div>
            <div class="col-6 d-flex justify-content-end align-items-end mt-2">
              <div id="order-footer" :class="orderStateClass(order.state)">
                {{ order.state }}
              </div>
            </div>
          </div>
      </div>
    </div>

    <OrderExpanded @fetchOrders="fetchOrders"
      :visible="modalDisplay"
      :order="order"
      @updateOrderDateDelivery="updateOrderDateDelivery"
      @updateOrderDateTakeAway="updateOrderDateTakeAway"
      @close="modalDisplay = false"
    ></OrderExpanded>
    <SpinnerComponent id="spinner"></SpinnerComponent>
    <div v-if="popup_open_kitchen" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style="background-color: rgba(139, 139, 139, 0.5); z-index: 1000;">
      <div class="bg-white border shadow-lg rounded p-4" style="max-width: 500px;">
        <h5 class="mt-2 text-center">¿Estás seguro?</h5>
        <h6 v-if="open_kitchen" class="mt-2 text-center">Si cierras la cocina, tus clientes no podrán pedir hasta que no vuelvas a abrirla.</h6>
        <h6 v-else class="mt-2 text-center">Si abres la cocina, tus clientes podrán volver a pedir.</h6>
        <div class="d-flex justify-content-center mt-4">
          <button class="btn btn-success me-3 px-5" @click="ChangeKitchenState">Si</button>
          <button class="btn btn-danger ms-3 px-5" @click="popup_open_kitchen=false">No</button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import OrderExpanded from '@/components/OrderExpanded.vue'
import SpinnerComponent from '../components/SpinnerComponent.vue'
import { mapState } from 'vuex';
import axios from 'axios';

import not_plates_founds from '@/assets/not_plates_founds.svg?raw';

export default {
data() {
  return {
      states:["PENDIENTE", "EN ESPERA", "EN CURSO", "EN CAMINO", "LISTO", "ENTREGADO", "PAGADO", "CANCELADO", "CANCELADO POR CLIENTE"],
      categories:[
        {
          id: [-1],
          name: "Todas"
        },
        {
          id: [0],
          name: "Pendientes"
        },
        {
          id: [1],
          name: "En espera"
        },
        {
          id: [2],
          name: "En curso"
        },
        {
          id: [3],
          name: "En camino"
        },
        {
          id: [4],
          name: "Listo"
        },
        {
          id: [5],
          name: "Entregadas"
        },
        {
          id: [6],
          name: "Pagadas"
        },
        {
          id: [7],
          name: "Canceladas"
        },
        {
          id: [8],
          name: "Cancelado por cliente"
        }
      ],
      orders: [],
      modalDisplay: false,
      order: null,
      activeCategoryId: [-1],
      first_charge: true,
      errorMessage: '',
      open_kitchen: null,
      popup_open_kitchen: false,
      not_plates_founds
    };
  },
  components:{
    OrderExpanded,
    SpinnerComponent
  },
  computed: {
    ...mapState(['partner_token'])
  },
  methods: {
    updateOrderDateDelivery(newDate) {
        // Aquí actualizas el valor de `order` de manera segura
        this.order.deliveries[0].final_data = newDate;
    },
    updateOrderDateTakeAway(newDate) {
        // Aquí actualizas el valor de `order` de manera segura
        this.order.take_aways[0].final_data = newDate;
    },
    ChangeCategory(category){
      this.activeCategoryId = category.id
    },
    formatTime(dateTime) {
      const parts = dateTime.split(' ');
      const timePart = parts[1];
      return timePart.split(':')[0] + ":" + timePart.split(':')[1];
    },
    FilterOrders(){
      let orders_filtered = []

      this.activeCategoryId.forEach(id => {
        orders_filtered = orders_filtered.concat(this.orders.filter(order => id == -1 || order.state === this.states[id]))
      });
      orders_filtered.sort((a, b) => new Date(a.date) - new Date(b.date))
      return orders_filtered
    },
    selectOrder(order) {
      this.order = order;
      this.modalDisplay = true;
    },
    orderStateClass(state) {
      return {
        'pendiente': state === 'PENDIENTE',
        'en-espera': state === 'EN ESPERA',
        'en-curso': state === 'EN CURSO',
        'en-camino': state === 'EN CAMINO',
        'listo': state === 'LISTO',
        'entregada': state === 'ENTREGADO',
        'pagada': state === 'PAGADO',
        'rechazada': state === 'CANCELADO',
        'cancelado-cliente': state === 'CANCELADO POR CLIENTE'
      };
    },
    async fetchOrders() {
      const token = this.partner_token;
      const url = process.env.VUE_APP_API_URL+'/v1/api/app/ActiveOrders';
      try {
        const response = await axios.get(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        let orders = response.data

        orders.forEach(order=>{
            try{
              order.table_number = order.table.number
              order.is_delivery = order.table.is_delivery
              order.is_take_away = order.table.is_take_away

              let min_state = null

              let plates_structure = []
              
              order.shopping_carts.forEach(shopping_cart=>{
                  let plate_structure = {}
                  plate_structure.shopping_cart_id = shopping_cart.id
                  plate_structure.plate_id = shopping_cart.plate.id
                  plate_structure.name = shopping_cart.plate.name
                  plate_structure.description = shopping_cart.plate.description
                  plate_structure.category=shopping_cart.plate.category
                  plate_structure.photo = shopping_cart.plate.photo
                  plate_structure.price = shopping_cart.plate.price
                  plate_structure.unit_price = shopping_cart.plate.price;
                  plate_structure.amount = shopping_cart.amount
                  plate_structure.comment = shopping_cart.comment
                  plate_structure.steps = shopping_cart.plate.steps

                  let i = 0
                  plate_structure.steps.forEach(step=>{
                    if(shopping_cart.steps_selected.length > i){
                      step.plate_selected = shopping_cart.steps_selected[i].plate
                    }
                    i++
                  })

                  // Ordenos los estados de cada plato de mayor a menor
                  shopping_cart.state_orders = shopping_cart.state_orders.sort((a, b) => {
                      return new Date(b.created_at)- new Date(a.created_at);
                  });

                  plate_structure.state = shopping_cart.state_orders[0].state
                  if (min_state == null || min_state[0] > plate_structure.state.sort){
                      min_state = [plate_structure.state.sort, plate_structure.state.name]
                  }

                  plate_structure.state = plate_structure.state.name

                  plates_structure.push(plate_structure)
              })

              order.plates = plates_structure

              order.state = min_state[1]
            }catch{
              console.log("error en un plato")
            }
        })
        let numero_pedidos_antes = this.orders.length
        this.orders = orders

        if (this.order != null){
          let order_selected = this.orders.find(item => item.id === this.order.id);
          if(order_selected){
            this.order = order_selected
          }
          else{
            this.modalDisplay = false
            this.order = null
          }
        }

        if(this.first_charge){
          document.getElementById("spinner").classList.add("d-none")
          this.first_charge=false
        }else{
          let veces_sonar = this.orders.length - numero_pedidos_antes
          console.log("veces_sonar:" + veces_sonar)
          let i = 0
          while(i<veces_sonar){
            this.playSound()
            await this.delay(1000);
            i++
          }
        }
      } catch (error) {
        // Maneja el error
        this.plates = []
        document.getElementById("spinner").classList.add("d-none")
        console.error('Error fetching orders:', error);
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    playSound() {
      // Carga el archivo de audio
      const audio = new Audio(require('@/assets/sonido_apple.mp3'));
      // Reproduce el audio
      audio.play().catch(error => console.log("Error reproduciendo el audio:", error));
    },
    async fetchKitchenState(){
      const url = process.env.VUE_APP_API_URL+'/v1/api/partner/getKitchenState';
      try {
          const response = await axios.get(url, {
              headers: {
              'Authorization': `Bearer ${this.partner_token}`
              }
          });
          this.open_kitchen = response.data
    
      } catch (error) {
          console.error('Error get kitchen state:', error);
      }
    },
    async ChangeKitchenState(){
      this.open_kitchen = !this.open_kitchen
      const url = process.env.VUE_APP_API_URL+'/v1/api/partner/putKitchenState';
      try {
          await axios.put(url,
              { new_state: this.open_kitchen },{
              headers: {
              'Authorization': `Bearer ${this.partner_token}`
              },
            }
          );
          this.fetchKitchenState()
          this.popup_open_kitchen = false
      } catch (error) {
          console.error('Error get kitchen state:', error);
      }
    },
    fetch(){
      this.fetchKitchenState();
      this.fetchOrders();
    },
    startPolling() {
        this.fetchKitchenState();
        this.fetchOrders();
        this.pollingInterval = setInterval(this.fetch, 15000); // Cada 15 segundos
    },
    stopPolling() {
      clearInterval(this.pollingInterval);
    }
  },
  created() {
    this.startPolling();
  },
  beforeUnmount() {
    this.stopPolling();
  },
};
</script>

<style scoped>

hr {
  color: var(--primary-color);
  margin: 0;
}

#orders-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  justify-items: center;
}

#order-card {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  width: 80%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: white;
}

#plates-list {
  max-height: 90px; 
  overflow-y: auto;
}

#plates-list::-webkit-scrollbar {
  width: 2px;
}

#plates-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--primary-color-rgb), 0.68);
  border-radius: 10px;
}

#order-footer {
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;
  font-weight: bold;
}

#order-footer.pendiente { color: red }
#order-footer.en-espera { color: red }
#order-footer.en-curso { color: var(--primary-color) }
#order-footer.en-camino { color: #00f4b9 }
#order-footer.listo { color: #00f4b9 }
#order-footer.entregada { color: green }
#order-footer.pagada { color: rgb(54, 117, 252) }
#order-footer.rechazada { color: rgb(129, 129, 129) }
#order-footer.cancelado-cliente { color: #a83232 }

@media (min-width: 768px) and (max-width: 1023px) {
  #orders-list {
    grid-template-columns: 1fr 1fr;
  }
  #order-card { 
    width: 90%;
  }
  
}

@media (min-width: 1024px) {
  #orders-list {
    grid-template-columns: 1fr 1fr 1fr;
  }
  #order-card { 
    width: 95%;
  }
  #categories-nav {
    justify-content: center !important;
  }
}

#categories-nav {
    display: flex;
    overflow-x: scroll;
    white-space: nowrap;
  }

  #categories-nav span{
    background-color: #f1f5f5;
    font-size: 1rem;
  }

  #categories-nav .active{
    background-color: var(--primary-color);
    color: white;
  }

  #categories-nav::-webkit-scrollbar{
    height: 2px;
  }

  #categories-nav::-webkit-scrollbar-thumb {
    background-color: rgba(var(--primary-color-rgb), 0.68);
    border-radius: 10px;
  }

  .form-check-input:checked {
    background-color: var(--primary-color);
    border: var(--primary-color);
  }
</style>
